import { render, staticRenderFns } from "./GitFlowList.vue?vue&type=template&id=5e5dc7f6&"
import script from "./GitFlowList.vue?vue&type=script&lang=js&"
export * from "./GitFlowList.vue?vue&type=script&lang=js&"
import style0 from "./GitFlowList.vue?vue&type=style&index=0&lang=less&"
import style1 from "./GitFlowList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports